var map = {
	"./BellaAura.png": 35010,
	"./CanadianWomenFoundation.png": 96542,
	"./Cuisivin.png": 86397,
	"./DestinationToronto.png": 57413,
	"./Hauslane.png": 14945,
	"./Hymnologie.png": 36264,
	"./Jow.png": 57667,
	"./LG.png": 72809,
	"./Meyer.png": 88526,
	"./NordicSunn.png": 23695,
	"./Remento.png": 24208,
	"./Unknow.png": 1173,
	"./citizen.png": 73305,
	"./whipdd.png": 60122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80406;